import React from "react";
import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "./../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import DropDownList from "../../../../../ReusableComponents/DropDownList/DropDownList";

export default function LicenceTypePopUp({
  token,
  list,
  PopUp,
  setPopUp,
  url,
  callBack,
  flage,
}) {
  const dispatch = useDispatch();
  const [value, setId] = useState();
  const [loading, setLoading] = useState();
  const setIdValue = (event) => {
    console.log("ms scc", event.target.value);
    setId(event.target.value);
  };
  const submitHandler = async (e) => {
    console.log(
      "list.map((e) => e.employee_id):::",
      list.map((e) => e.employee_id)
    );
    e.preventDefault();
    var body =
      flage === false
        ? {
            employee_ids: list.map((e) => e.employee_id),
            license_type: value,
          }
        : list.map((data) => ({
            employee_id: data.employee_id,
            baladiya_location: value,
            apply_date: data.baladiya_apply_date,
            issue_date: data.baladiya_issue_date,
            expiry_date: data.baladiya_expiry_date,
            license_type: data.license_type,
            admission_fee: data.admission_fee,
            medical_fee: data.medical_fee,
            govt_fee: data.govt_fee,
            inducement_fee: data.inducement_fee,
          }));
    try {
      const res = await nodeinstance.post(url, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setPopUp(false);
        callBack();
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={(e) => submitHandler(e)}
            className="w-full place-items-center"
          >
            <div className="w-full flex flex-col gap-3 my-3 p-5 place-items-center">
              <div className="flex flex-col gap-1 text-center">
                <label className="text-sm">Update Licence Type</label>
                <label className="text-sm">Licence Type</label>
                <DropDownList
                  value={""}
                  setValue={setIdValue}
                  presetValues={[
                    { value: "Personal driving license" },
                    { value: "Commercial driving license" },
                    { value: "Light Transport" },
                    { value: "Heavy Transport" },
                    { value: "small Bus" },
                    { value: "Large Bus" },
                    { value: "MotorCycle" },
                    { value: "Private" },
                    { value: "Public Works Vechile" },
                    { value: "Temporary License Permit" },
                  ]}
                />
              </div>
              <button
                type="submit"
                className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
              >
                {" "}
                <p>Submit</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
